import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ScrollToTopButtonTemplate } from 'themes/components';

class ScrollToTopButton extends Component {
  render() {
    return <ScrollToTopButtonTemplate {...this.props} />;
  }
}

ScrollToTopButton.propTypes = {
  scrollThreshold: PropTypes.number,
  className: PropTypes.string,
  style: PropTypes.object,
  title: PropTypes.string
};

export default ScrollToTopButton;
